import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomFilterPipe } from "./custom-filter.pipe";
import { PhonePipe } from "./phone.pipe";
import { SafePipe } from "./safe.pipe";
import { IdentificationPipe } from "./identification.pipe";
import { SplitFilterPipe } from "./split-filter.pipe";
import { TimePipe } from "./time.pipe";
import { TimeSecondPipe } from "./timeSecond.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [
    CustomFilterPipe,
    PhonePipe,
    SafePipe,
    IdentificationPipe,
    SplitFilterPipe,
    TimePipe,
    TimeSecondPipe,
  ],
  exports: [
    CustomFilterPipe,
    PhonePipe,
    SafePipe,
    IdentificationPipe,
    SplitFilterPipe,
    TimePipe,
    TimeSecondPipe,
  ],
})
export class PipeModule {}
